import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-section">
      <div className="about-content">
        <h2>About Team Ray</h2>
        <p>
          Team Ray is the official aerospace student society of the University of Huddersfield, bringing together aspiring engineers and innovators to tackle real-world space challenges. In 2025, we proudly represent our university in the prestigious UKSEDS Olympus Rover Trials — a national competition that simulates designing and operating a rover for an analogue space mission.
        </p>
        <p>
          The competition pushes teams through rigorous systems engineering tasks, hands-on development, and critical design reviews judged by leading space sector engineers. It’s more than a race — it's a platform to learn, collaborate, and demonstrate engineering excellence in robotics, autonomy, and space technology.
        </p>
      </div>
    </div>
  );
};

export default About;
